import { now } from '@01edu/time'

const DAY = 60 * 60 * 24

export type LicenseStatus = 'active' | 'coming' | 'expired'
export type CoverageStatus = LicenseStatus | 'none'

export const getLicenseStatus = (
  startAt: number,
  endAt: number,
): LicenseStatus => {
  const currentTime = now()
  if (currentTime < startAt) return 'coming'
  if (endAt === -1) return 'active'
  if (currentTime > endAt) return 'expired'
  return 'active'
}

export const daysLeft = (endAt: number) =>
  Math.max(0, Math.floor((endAt - now()) / DAY))

export const STATUS = {
  active: {
    label: 'Active',
    badge: 'badge-success',
    btn: 'btn-success',
    bg: 'bg-success',
    border: 'border-success',
  },
  coming: {
    label: 'Coming',
    badge: 'badge-info',
    btn: 'btn-info',
    bg: 'bg-info',
    border: 'border-info',
  },
  expired: {
    label: 'Expired',
    badge: 'badge-error',
    btn: 'btn-error',
    bg: 'bg-error',
    border: 'border-error',
  },
} as const
